"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'storeDetailList',
      currPage: 1,
      limit: 10,
      total: 0,
      sourceApi: null,
      queryMonth: '',
      list: [],
      province: '',
      city: '',
      regionOptions: [],
      cityOptions: [],
      listLoading: false
    };
  },
  created: function created() {
    this.queryMonth = this.$route.query.month;
  },
  mounted: function mounted() {
    this.fetchRegionList();
    this.fetchList();
  },
  methods: {
    // 获取省市区数据
    fetchRegionList: function fetchRegionList() {
      var _this = this;
      var regionOptions = this.$store.getters.getRegionData("level_2");
      if (Array.isArray(regionOptions) && regionOptions.length) {
        this.regionOptions = regionOptions;
        return;
      }
      this.$api.common.getRegionList(2).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this.regionOptions = responseData.data || [];
          _this.$store.dispatch('baseData/saveRegionDataByLevel', {
            key: "level_2",
            regionData: responseData.data || []
          });
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    resetData: function resetData() {
      this.province = '';
      this.cityOptions = [];
      this.city = '';
      this.currPage = 1;
      this.limit = 10;
      this.total = 0;
      this.fetchList();
    },
    querySearch: function querySearch() {
      this.currPage = 1;
      this.fetchList();
    },
    provinceChange: function provinceChange(province) {
      this.city = '';
      var provinceInfo = this.regionOptions.find(function (item) {
        return item.value === province;
      });
      if (provinceInfo && provinceInfo.children) {
        this.cityOptions = provinceInfo.children;
      } else {
        this.cityOptions = [];
      }
    },
    fetchList: function fetchList() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          month: this.queryMonth,
          provinceCodeList: this.province ? [this.province] : [],
          cityCodeList: this.city ? [this.city] : []
        }
      };
      this.listLoading = true;
      this.$api.reportModule.getStoreDetailList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items || [];
        _this2.total = res.data.totalCount || 0;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    downloadExcel: function downloadExcel(name) {
      var _this3 = this;
      var param = {
        month: this.queryMonth,
        provinceCodeList: this.province ? [this.province] : [],
        cityCodeList: this.city ? [this.city] : []
      };
      this.isLoading = true;
      this.$api.reportModule.exportStoreDetailList(param).then(function (res) {
        _this3.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this3.isLoading = false;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};